import { ImportStateMapping } from 'volta/_pods/protected/import/controller';

import { service } from '@ember/service';
import Component from '@glimmer/component';

import type IntlService from 'ember-intl/services/intl';
import type { TOptions } from 'ember-intl/services/intl';
import type { IBvTableBaseCellArgs } from 'volta/components/cell/base-cell';
import type ImportHisto from 'volta/models/import-histo';

export default class TableNameCell extends Component<IBvTableBaseCellArgs> {
  @service intl!: IntlService;

  get importHisto() {
    return this.args.row.rowValue as ImportHisto | undefined;
  }

  get status() {
    const { importHisto } = this;
    if (!importHisto) {
      return undefined;
    }
    return importHisto.isImportLoading
      ? 'importing'
      : importHisto.isImportError
      ? 'error'
      : importHisto.isImportWarning
      ? 'warning'
      : 'success';
  }

  get state() {
    return this.status ? ImportStateMapping[this.status] : undefined;
  }

  get tooltip() {
    const { status, importHisto, intl } = this;
    switch (status) {
      case 'error':
        return importHisto?.errorMsg && intl.exists(importHisto.errorMsg)
          ? intl.t(importHisto.errorMsg, (importHisto.errorContext ?? {}) as TOptions)
          : importHisto?.errorMsg;
      case 'importing':
        return intl.t(ImportStateMapping.importing.label);
      case 'warning':
        return intl.t('importsPage.warningMessage');
      default:
        return undefined;
    }
  }
}
